import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  useMediaQuery,
  Button,
} from "@mui/material";
import * as XLSX from "xlsx";
import { DatePicker } from "@mui/x-date-pickers";
import DescriptionIcon from "@mui/icons-material/Description";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import SendIcon from "@mui/icons-material/Send";
import "./ItemApprove.css";
import {
  exportToExcel,
  ItemCreationRejectionReasonsAPI,
  ItemReqGetRowExportAPI,
  ITEMSREQLoadAPI,
  ITEMSREQPostANDRejectAPI,
} from "./ItemApproveRequestAction";
import { useSelector } from "react-redux";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import { ItemApproveRequestRo } from "../../Redux/roStore";
import {
  CmpStatusIcon,
  CmpTypographyNew,
} from "../../Component/Common/ToolBox/ToolBox";
import ItemApprove_Breadcrumbs from "./ItemApprove_Breadcrumbs";
import { confirmAlert } from "react-confirm-alert";
import { useNavigate } from "react-router-dom";
import ItemApproveDetailGrid from "./component/ItemApproveDetailGrid";

const ItemApproveDetail = () => {
  const navigate = useNavigate();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const aMediaQuery = useMediaQuery("(max-width:900px)");
  const [detailGridData, setDetailGridData] = useState([]);
  const [detailExcelData, setDetailExcelData] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [rejectionReason, setRejectionReason] = useState([]);
  const lineStatus = ["ACCEPT", "MODIFY", "REJECT"];

  const vRdxuserInfo = useSelector((state) => state.login.value);
  const headObj = useSelector(
    (state) => state.SliceItemApproveRequest.value?.Head
  );

  const bRspRefs = useRef([]);
  const skuRefs = useRef([]);
  const fileInputRef = useRef(null);
  const [filePath, setFilePath] = useState(null);

  const fLoadGrid = async (iReasonArr = rejectionReason) => {
    let { Head } = ItemApproveRequestRo();
    const Obj = {
      Id: Head?.A_Id,
    };

    let response = await ITEMSREQLoadAPI(
      fcheck_null_undefine_replace_empty(Obj)
    );

    if (response?.status === 200 && response?.data?.ResultSet?.length > 0) {
      let UpdateGrid = response?.data?.ResultSet?.map((item, i) => {
        const rejectionReasons = item?.B_Rejection_reason?.split(",").map(
          (reason) => reason?.trim()
        );
        const filteredRejectionReasons = iReasonArr?.filter((reasonObj) =>
          rejectionReasons?.includes(reasonObj.UId)
        );
        return {
          ...item,
          rejectReason: filteredRejectionReasons,
          id: i + 1,
        };
      });
      setDetailGridData(UpdateGrid);
      setTimeout(() => {
        document.getElementById("ApproveItemName")?.focus();
      }, 1000);
    } else {
      setDetailGridData([]);
    }
  };

  const fetchRejectionReasons = async () => {
    const response = await ItemCreationRejectionReasonsAPI();
    if (response?.status === 200) {
      setRejectionReason(response?.data?.data || []);
      return response?.data?.data;
    }
  };

  const fSave = async () => {
    const invalidItem = detailGridData.find((item) => {
      if (item.B_Line_Status === "REJECT") {
        return !item.B_Narration || item.B_Narration.trim() === "";
      }
      if (item.B_Line_Status === "MODIFY") {
        return (
          !item.B_Rejection_reason || item.B_Rejection_reason.trim() === ""
        );
      }
      return (
        !item.B_RSP ||
        item.B_RSP === "" ||
        !item.SKU ||
        item.SKU === "" ||
        item.SKU == 0
      );
    });

    if (invalidItem) {
      if (invalidItem.B_Line_Status === "REJECT") {
        fAlertToast(
          "FAILED",
          `For ${invalidItem.B_Line_Status} document, Narration should not be empty.`
        );
        return;
      }
      if (invalidItem.B_Line_Status === "MODIFY") {
        fAlertToast(
          "FAILED",
          `For ${invalidItem.B_Line_Status} document, At least one rejection reason must be selected.`
        );
        return;
      }
      if (!invalidItem.B_RSP || invalidItem.B_RSP === "") {
        fAlertToast("FAILED", "Selling Price should not be empty.");
        return;
      }
      if (!invalidItem.SKU || invalidItem.SKU === "" || invalidItem.SKU == 0) {
        fAlertToast(
          "FAILED",
          invalidItem.SKU === ""
            ? "Article no should not be empty"
            : "Article no should not be Zero"
        );
        return;
      }
    } else {
      let { Head } = ItemApproveRequestRo();

      const items = detailGridData.map((item) => ({
        P_A_Id: headObj?.A_Id || 0,
        P_B_ItemName: item?.B_ItemName || "",
        P_B_ItemNameFL: item?.B_ItemNameFL || "",
        P_B_Barcode: item?.B_Barcode || "",
        P_B_Category: item?.B_Category || "",
        P_B_SubCategory: item?.B_SubCategory || "",
        P_B_MainCategory: item?.B_MainCategory || "",
        P_B_Packing: item?.B_Packing || "",
        P_B_Brand: item?.B_Brand || "",
        P_B_Vendor: item?.B_Vendor || "",
        P_B_CostPr: item?.B_CostPr || "",
        P_B_Rejection_reason: item?.B_Rejection_reason || "",
        P_B_Narration: item?.B_Narration || "",
        P_B_RSP: item?.B_RSP || 0,
        P_B_SuppRefNo1: item?.SKU || 0,
        P_B_Line_Status: item?.B_Line_Status,
      }));
      const Obj = {
        P_A_Id: Head?.A_Id,
        Items: items,
        P_A_Status: "",
        P_UserCd: vRdxuserInfo.UserID,
      };
      let response = await ITEMSREQPostANDRejectAPI(Obj);

      if (response?.status === 200) {
        fAlertToast("SUCCESS", "Successfully Saved");
        fLoadGrid();
      }
    }
  };

  const fApprove = async () => {
    const invalidItem = detailGridData.find((item) => {
      if (item.B_Line_Status === "REJECT") {
        return !item.B_Narration || item.B_Narration.trim() === "";
      }
      if (item.B_Line_Status === "MODIFY") {
        return (
          !item.B_Rejection_reason || item.B_Rejection_reason.trim() === ""
        );
      }
      return !item.SKU || item.SKU === "" || item.SKU == 0;
    });
    // const invalidItem = detailGridData.find(
    //   (item) => !item.SKU || item?.SKU == ""
    // );

    if (invalidItem) {
      if (invalidItem.B_Line_Status === "REJECT") {
        fAlertToast("FAILED", "Narration should not be empty.");
        return;
      }
      if (invalidItem.B_Line_Status === "MODIFY") {
        fAlertToast(
          "FAILED",
          "At least one rejection reason must be selected."
        );
        return;
      }
      if (!invalidItem.SKU || invalidItem.SKU === "" || invalidItem.SKU == 0) {
        fAlertToast(
          "FAILED",
          invalidItem.SKU === ""
            ? "Article no should not be empty"
            : "Article no should not be Zero"
        );
        return;
      }
      // fAlertToast("FAILED", "Article no should not be empty.");
      // return;
    } else {
      const items = detailGridData.map((item) => ({
        P_A_Id: headObj?.A_Id || 0,
        P_B_ItemName: item?.B_ItemName || "",
        P_B_ItemNameFL: item?.B_ItemNameFL || "",
        P_B_Barcode: item?.B_Barcode || "",
        P_B_Category: item?.B_Category || "",
        P_B_SubCategory: item?.B_SubCategory || "",
        P_B_MainCategory: item?.B_MainCategory || "",
        P_B_Packing: item?.B_Packing || "",
        P_B_Brand: item?.B_Brand || "",
        P_B_Vendor: item?.B_Vendor || "",
        P_B_CostPr: item?.B_CostPr || "",
        P_B_Rejection_reason: item?.B_Rejection_reason || "",
        P_B_Narration: item?.B_Narration || "",
        P_B_RSP: item?.B_RSP || 0,
        P_B_SuppRefNo1: item?.SKU || 0,
        P_B_Line_Status: item?.B_Line_Status,
      }));

      confirmAlert({
        title: "Approve",
        message: "Are you want to Approve?",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: async () => {
              let { Head } = ItemApproveRequestRo();
              const Obj = {
                P_A_Id: Head?.A_Id,
                Items: items,
                P_A_Status: "POST",
                P_UserCd: vRdxuserInfo.UserID,
              };
              let response = await ITEMSREQPostANDRejectAPI(Obj);

              if (response?.status === 200) {
                fAlertToast("SUCCESS", "Approved successfully");
                fLoadGrid();
                navigate("/ItemApproveSummary");
              }
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };

  const fReject = async () => {
    const items = detailGridData.map((item) => ({
      P_A_Id: headObj?.A_Id || 0,
      P_B_ItemName: item?.B_ItemName || "",
      P_B_ItemNameFL: item?.B_ItemNameFL || "",
      P_B_Barcode: item?.B_Barcode || "",
      P_B_Category: item?.B_Category || "",
      P_B_SubCategory: item?.B_SubCategory || "",
      P_B_MainCategory: item?.B_MainCategory || "",
      P_B_Packing: item?.B_Packing || "",
      P_B_Brand: item?.B_Brand || "",
      P_B_Vendor: item?.B_Vendor || "",
      P_B_CostPr: item?.B_CostPr || "",
      P_B_Rejection_reason: item?.B_Rejection_reason || "",
      P_B_Narration: item?.B_Narration || "",
      P_B_RSP: item?.B_RSP || 0,
      P_B_SuppRefNo1: item?.SKU || 0,
      P_B_Line_Status: item?.B_Line_Status,
    }));

    confirmAlert({
      title: "Reject",
      message: "Are you want to Reject?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: async () => {
            let { Head } = ItemApproveRequestRo();
            const Obj = {
              P_A_Id: Head?.A_Id,
              Items: items,
              P_A_Status: "REJECT",
              P_UserCd: vRdxuserInfo.UserID,
            };
            let response = await ITEMSREQPostANDRejectAPI(Obj);

            if (response?.status === 200) {
              fAlertToast("SUCCESS", "Rejected successfully");
              fLoadGrid();
              navigate("/ItemApproveSummary");
            }
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => "",
        },
      ],
    });
  };

  const fItemReqGetRowExport = async () => {
    let { Head } = ItemApproveRequestRo();
    const response = await ItemReqGetRowExportAPI({ A_Id: Head?.A_Id });

    if (response.status === 200) {
      setExcelData(response?.data?.data || []);
    }
  };

  const handleChange = (index, event) => {
    const { name, value } = event.target;
    const updatedDiscountData = [...detailGridData];
    updatedDiscountData[index][name] = value; // Update the specific row and field
    setDetailGridData(updatedDiscountData);
  };

  const handleRefNoKeyDown = (e, index) => {
    if (e.key === "Enter") {
      if (index === detailGridData?.length - 1) {
        fSave();
      } else {
        bRspRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleBRSPKeyDown = (e, index) => {
    if (e.key === "Enter") {
      skuRefs.current[index]?.focus();
    }
  };

  function updateGridData(gridData, excelData) {
    const excelLookup = Object.fromEntries(
      excelData.map((item) => [item.Barcode, item])
    );

    console.log("excelLookup", excelLookup);

    return gridData.map((gridItem) => ({
      ...gridItem,
      B_RSP: excelLookup[gridItem.B_Barcode]?.["RSP"] || gridItem.B_RSP,
      SKU:
        excelLookup[gridItem.B_Barcode]?.["Article Number"] ||
        excelLookup[gridItem.B_Barcode]?.["SKU"] ||
        gridItem.SKU,
      B_Line_Status:
        excelLookup[gridItem.B_Barcode] && gridItem.B_Line_Status === "REJECT"
          ? "ACCEPT"
          : gridItem.B_Line_Status,
    }));
  }

  const fImport = () => {
    if (filePath == "" || filePath == null || filePath == undefined) {
      fAlertToast("FAILED", "Choose one file");
      return;
    } else {
      const updatedGridData = updateGridData(detailGridData, detailExcelData);
      console.log("updatedGridData", updatedGridData);
      setDetailGridData(updatedGridData);
      fAlertToast("SUCCESS", "File uploaded");
      setFilePath("");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFilePath(file.name); // Update the file path in state

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(sheet); // Convert sheet to JSON

        setDetailExcelData(excelData);
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const fExport = () => {
    exportToExcel(excelData, "ItemApprove_data", "ItemApprove");
  };

  const onLoad = async () => {
    let iRejection = await fetchRejectionReasons();
    await fLoadGrid(iRejection);
    await fItemReqGetRowExport();
  };
  useEffect(() => {
    onLoad();
  }, []);

  return (
    <div className="my-2">
      <div className="Breadcrumbs d-flex">
        <ItemApprove_Breadcrumbs />
      </div>
      <div className="ItemRequest-detailhead">
        <Box
          className="ItemRequest-headInfo"
          sx={{
            paddingX: vMediaQuery ? "8px" : aMediaQuery ? 2 : 4,
            paddingY: aMediaQuery ? 1 : 1.5,
            borderRadius: 3,
            boxShadow: 1,
            backgroundColor: "#f9f9f96e",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              variant={vMediaQuery ? "subtitle1" : "h6"}
              sx={{
                color: "#424242",
                marginBottom: vMediaQuery ? 0 : 0.5,
                textDecoration: "underline",
              }}
            >
              Item Approve Request
            </Typography>
            <div style={{ marginTop: vMediaQuery ? 4 : 0 }}>
              <CmpStatusIcon xStatus={headObj?.A_Status} />
            </div>
          </div>

          <Grid
            container
            columnSpacing={vMediaQuery ? 1 : aMediaQuery ? 2 : 10}
            rowSpacing={vMediaQuery ? 2 : 0}
            padding={vMediaQuery ? 0.5 : aMediaQuery ? 1 : 2}
            paddingX={vMediaQuery ? 0 : 2}
          >
            {/* Left Column (Trans ID and Trans Date) */}
            <Grid item xs={12} sm={6} md={6}>
              <Grid container direction="column" spacing={1}>
                {/* Trans ID */}
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={3} sm={3} md={2}>
                      <CmpTypographyNew xText={"Trans ID"} />
                    </Grid>
                    <Grid item xs={1} sm={1} md={0.5}>
                      <CmpTypographyNew xText={":"} />
                    </Grid>
                    <Grid item xs={8} sm={8} md={9}>
                      <TextField
                        fullWidth
                        name="A_Id"
                        value={headObj?.A_Id}
                        disabled={true}
                        inputProps={{ readOnly: true }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {/* Trans Date */}
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={3} sm={3} md={2}>
                      <CmpTypographyNew xText={"Trans Date"} />
                    </Grid>
                    <Grid item xs={1} sm={1} md={0.5}>
                      <CmpTypographyNew xText={":"} />
                    </Grid>
                    <Grid item xs={8} sm={8} md={9}>
                      <DatePicker
                        name="A_Date"
                        value={headObj?.A_Date}
                        renderInput={(params) => (
                          <TextField fullWidth {...params} id="transDate" />
                        )}
                        disabled={true}
                        inputProps={{ readOnly: true }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {/* Right Column (Location and B_Narration) */}
            <Grid item xs={12} sm={6} md={6}>
              <Grid container direction="column" spacing={1}>
                {/* Location */}
                <Grid item xs={12}>
                  <Grid container>
                    <Grid xs={3} sm={3} md={2}>
                      <CmpTypographyNew xText={"Location"} />
                    </Grid>
                    <Grid item xs={1} sm={1} md={0.5}>
                      <CmpTypographyNew xText={":"} />
                    </Grid>
                    <Grid item xs={8} sm={8} md={9}>
                      <TextField
                        fullWidth
                        name="A_Loc"
                        value={headObj?.A_LocName}
                        InputProps={{
                          startAdornment: (
                            <LocationOnIcon sx={{ marginRight: 1 }} />
                          ),
                        }}
                        disabled={true}
                        inputProps={{ readOnly: true }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {/* Narration */}
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={3} sm={3} md={2}>
                      <CmpTypographyNew xText={"Narration"} />
                    </Grid>
                    <Grid item xs={1} sm={1} md={0.5}>
                      <CmpTypographyNew xText={":"} />
                    </Grid>
                    <Grid item xs={8} sm={8} md={9}>
                      <TextField
                        fullWidth
                        name="A_Narr"
                        autoComplete="off"
                        value={headObj?.A_Narr}
                        multiline
                        InputProps={{
                          startAdornment: (
                            <DescriptionIcon sx={{ marginRight: 1 }} />
                          ),
                        }}
                        disabled={true}
                        inputProps={{ readOnly: true }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <ItemApproveDetailGrid
            filePath={filePath}
            headObj={headObj}
            vMediaQuery={vMediaQuery}
            handleFileChange={handleFileChange}
            fImport={fImport}
            fExport={fExport}
            detailGridData={detailGridData}
            setDetailGridData={setDetailGridData}
            bRspRefs={bRspRefs}
            handleRefNoKeyDown={handleRefNoKeyDown}
            skuRefs={skuRefs}
            handleBRSPKeyDown={handleBRSPKeyDown}
            handleChange={handleChange}
            rejectionReason={rejectionReason}
            docStatus={lineStatus}
            fileInputRef={fileInputRef}
          />

          <Grid
            container
            textAlign={"right"}
            spacing={{ xs: 1.5, sm: 2, md: 2 }}
            paddingX={vMediaQuery ? 0.5 : aMediaQuery ? 1 : 2}
            sx={{
              maxWidth: "100%",
              justifyContent: vMediaQuery ? "center" : "flex-end",
            }}
          >
            <Grid item xs={5.5} sm={2} md={1.5} lg={1}>
              <Button
                fullWidth
                variant="contained"
                color="secondary"
                size={vMediaQuery ? "small" : "large"}
                endIcon={<SaveIcon />}
                sx={{
                  borderRadius: 3,
                  boxShadow: 2,
                  paddingX: 3,
                  color: "#0d73bb",
                  textTransform: "capitalize",
                }}
                disabled={headObj?.A_Status != "ENTER"}
                onClick={fSave}
              >
                Save
              </Button>
            </Grid>

            <Grid item xs={5.5} sm={2} md={1.5} lg={1}>
              <Button
                fullWidth
                variant="contained"
                size={vMediaQuery ? "small" : "large"}
                color="success"
                endIcon={<SendIcon />}
                sx={{
                  borderRadius: 3,
                  boxShadow: 2,
                  paddingX: 3,
                  textTransform: "capitalize",
                }}
                disabled={headObj?.A_Status != "ENTER"}
                onClick={fApprove}
              >
                Post
              </Button>
            </Grid>
            <Grid item xs={5.5} sm={2} md={1.5} lg={1}>
              <Button
                fullWidth
                variant="contained"
                color="error"
                size={vMediaQuery ? "small" : "large"}
                endIcon={<DeleteIcon />}
                onClick={fReject}
                sx={{
                  borderRadius: 3,
                  boxShadow: 2,
                  paddingX: 3,
                  "&:hover": { backgroundColor: "#d32f2f" },
                }}
                disabled={headObj?.A_Status != "ENTER"}
              >
                Reject
              </Button>
            </Grid>
          </Grid>
        </Box>
      </div>
    </div>
  );
};

export default ItemApproveDetail;
